<template>
</template>

<script>
	export default{
		data(){
			this.$router.replace({
				path:'/typeSetting'
			})
		}
	}
</script>

<style>
</style>
